import logoPse from "../assets/logos/Medios de pago - Logos/PSE.png";
import logoNequi from "../assets/logos/Medios de pago - Logos/Nequi.png";
import logoDaviplata from "../assets/logos/Medios de pago - Logos/Daviplata.png";
import logoDavivienda from "../assets/logos/Medios de pago - Logos/Davivienda.png";
import logoBreb from "../assets/logos/Medios de pago - Logos/Bre-B.png";
import logoEfecty from "../assets/logos/Medios de pago - Logos/Efecty.jpg";
import logoSuperGiros from "../assets/logos/Medios de pago - Logos/Super Giros.png";
import logoPuntoRed from "../assets/logos/Medios de pago - Logos/Punto Red.png";
import logoBeMovil from "../assets/logos/Medios de pago - Logos/Be Movil.png";
import logoConSuerte from "../assets/logos/Medios de pago - Logos/Con Suerte.png";
import logoGanaGana from "../assets/logos/Medios de pago - Logos/GanaGana.png";
import logoMoviiRed from "../assets/logos/Medios de pago - Logos/Movii Red.png";
import logoPuntoPago from "../assets/logos/Medios de pago - Logos/Punto de pago.png";
import logoMaxiServi from "../assets/logos/Medios de pago - Logos/MaxiServi.png";
import logoFullcarga from "../assets/logos/Medios de pago - Logos/Fullcarga.png";
import logoRefacil from "../assets/logos/Medios de pago - Logos/Refacil.png";
import logoJer from "../assets/logos/Medios de pago - Logos/JER.png";
import logoAccionesValores from "../assets/logos/Medios de pago - Logos/Acciones y Valores.png";

/** Logos oficiales de medios de pago (carpeta src/assets/logos/Medios de pago - Logos). */
export const OFFICIAL_PAYMENT_LOGOS = [
  { image_url: logoPse, alt: "PSE" },
  { image_url: logoNequi, alt: "Nequi" },
  { image_url: logoDaviplata, alt: "Daviplata" },
  { image_url: logoDavivienda, alt: "Davivienda" },
  { image_url: logoBreb, alt: "Bre-B" },
  { image_url: logoEfecty, alt: "Efecty" },
  { image_url: logoSuperGiros, alt: "Super Giros" },
  { image_url: logoPuntoRed, alt: "Punto Red" },
  { image_url: logoBeMovil, alt: "Be Móvil" },
  { image_url: logoConSuerte, alt: "Con Suerte" },
  { image_url: logoGanaGana, alt: "Gana Gana" },
  { image_url: logoMoviiRed, alt: "Movii Red" },
  { image_url: logoPuntoPago, alt: "Punto de pago" },
  { image_url: logoMaxiServi, alt: "MaxiServi" },
  { image_url: logoFullcarga, alt: "Fullcarga" },
  { image_url: logoRefacil, alt: "Refácil" },
  { image_url: logoJer, alt: "JER" },
  { image_url: logoAccionesValores, alt: "Acciones y Valores" },
];
